import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { NotificationRuleRegionType } from '../models/injection';

interface NotificationRuleRegionSelectProps {
  value: NotificationRuleRegionType;
  onChange?: (event: React.ChangeEvent<{}>, value: NotificationRuleRegionType) => void;
  cssClass?: string;
  fullWidth?: boolean;
  selectId?: string;
  labelText?: string;
}

const NotificationRuleRegionSelect = ({
  value,
  onChange,
  cssClass,
  fullWidth,
  selectId,
  labelText
}: NotificationRuleRegionSelectProps) => {
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const supplyValue = event.target.value as NotificationRuleRegionType;

    //callback
    onChange && onChange(event, supplyValue);
  };

  const translations: Record<string, string> = {
    [NotificationRuleRegionType.Unknown]: 'f-any',
    [NotificationRuleRegionType.Injection]: 'm-notification-rule-area-injection',
    [NotificationRuleRegionType.Mortality]: 'm-notification-rule-area-mortality'
  };

  const getTypes = () => {
    const types = [];
    for (const key in NotificationRuleRegionType) {
      if (isNaN(Number(key))) {
        const id = NotificationRuleRegionType[key as keyof typeof NotificationRuleRegionType];
        if (id !== NotificationRuleRegionType.Unknown) {
          types.push({
            id,
            name: t(translations[id])
          });
        }
      }
    }
    return types;
  };

  return (
    <FormControl className={cssClass} fullWidth={fullWidth} variant="outlined" size="small">
      <InputLabel id="notificationRuleRegionSelect">{labelText || t('f-notification-rule-area-select')}</InputLabel>
      <Select
        label={t('f-notification-rule-area-select')}
        labelId="notificationRuleRegionSelect"
        id={selectId || 'notificationRuleRegionSelect'}
        value={value}
        onChange={handleChange}
      >
        {getTypes().map((type) => (
          <MenuItem key={type.id} value={type.id}>
            {type.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default NotificationRuleRegionSelect;
